import { InternalDatabaseService } from '@stockcare-storage/internal/internal-database.service';
import { Injectable } from '@angular/core';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { PatientNotes } from '@stockcare-models/IPatientNotes';

@Injectable({
  providedIn: 'root',
})
export class PatientNoteStorageService {
  readonly barcodeIndex: string;
  patientNotes: PatientNotes[] = [];
  constructor(
    private internalDatabaseService: InternalDatabaseService,
    private readonly settingsService: SettingsService,
    private readonly deviceService: DeviceService
  ) {}

  async addPatientNotes(patientNotes: PatientNotes[]) {
      var allNotes = this.patientNotes.concat(patientNotes);
      this.patientNotes = [...allNotes];
  }

  async getPatientNotes(caseNumber: string): Promise<PatientNotes[]> {
    const patientNotes = this.patientNotes.filter((patientNote) => patientNote.caseNumber === caseNumber);
    return [...patientNotes];
  }

  async deleteAllByCaseByNumber(caseNumber: string) {
    var patientNotes = this.patientNotes.filter((patientNote) => patientNote.caseNumber != caseNumber);
    this.patientNotes = [...patientNotes];
  }
}
